React = require 'react'
createReactClass = require 'create-react-class'
PropTypes = require 'prop-types'

Spinner = ({style, color}) ->
  color = color || "currentColor"

  <svg width="18px" height="15px" viewBox="0 0 18 15" style={style}>
    <rect x="0" y="0" width="4" height="15" fill={color}>
      <animate attributeName="opacity"
        values="1; .2; 1"
        begin="0s" dur="0.6s" repeatCount="indefinite" />
    </rect>
    <rect x="7" y="0" width="4" height="15" fill={color}>
      <animate attributeName="opacity"
        values="1; .2; 1"
        begin="0.2s" dur="0.6s" repeatCount="indefinite" />
    </rect>
    <rect x="14" y="0" width="4" height="15" fill={color}>
      <animate attributeName="opacity"
        values="1; .2; 1"
        begin="0.4s" dur="0.6s" repeatCount="indefinite" />
    </rect>
  </svg>

module.exports = Spinner